import { render, staticRenderFns } from "./design-webshop-ticket-container.vue?vue&type=template&id=07ace64a&scoped=true"
import script from "./design-webshop-ticket-container.vue?vue&type=script&lang=js"
export * from "./design-webshop-ticket-container.vue?vue&type=script&lang=js"
import style0 from "./design-webshop-ticket-container.vue?vue&type=style&index=0&id=07ace64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ace64a",
  null
  
)

export default component.exports